import type { DropdownProperties, FormElement } from '../../model/form.types';
import type { FieldDefinition, FieldValue, SelectOption, ValidationIssue } from '../../model/types';
import {
  normalizeOption,
  selectedStrings,
  selectionShapeIssue,
  singleColumn,
  valueAsText,
  validateSelection,
} from './shared';

type DropdownElement = FormElement & { properties: DropdownProperties };

function options(element: DropdownElement): SelectOption[] {
  return (element.properties.alternatives ?? []).map((alternative) => ({
    value: alternative.value,
    label: alternative.value,
  }));
}

function shapeIssue(element: DropdownElement, value: FieldValue): ValidationIssue | null {
  return selectionShapeIssue(element, value, element.properties.multipleSelection === true);
}

export const dropdownDefinition: FieldDefinition<DropdownElement> = {
  kind: 'field',
  type: 'DROPDOWN',
  emptyValue: (element) => (element.properties.multipleSelection ? [] : ''),
  control: (element) => ({
    kind: 'select',
    options: options(element),
    multiple: element.properties.multipleSelection === true,
    placeholder: element.properties.placeholder,
  }),
  shapeIssue,
  validate: (element, value) =>
    validateSelection(
      element,
      value,
      options(element).map((option) => option.value),
      element.properties.multipleSelection === true,
    ),
  columns: singleColumn,
  cells: (_element, value) => [valueAsText(value)],
  triggerMatches: (_element, value, option) =>
    selectedStrings(value).some((selected) => normalizeOption(selected) === normalizeOption(option)),
};
